module.exports = __webpack_public_path__ + "img/bb_g1_t_mouth-02.fda489a1.svg";